import { render, staticRenderFns } from "./Fade.vue?vue&type=template&id=c776e558&scoped=true&"
import script from "./Fade.vue?vue&type=script&lang=js&"
export * from "./Fade.vue?vue&type=script&lang=js&"
import style0 from "./Fade.vue?vue&type=style&index=0&id=c776e558&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c776e558",
  null
  
)

export default component.exports